<script setup lang="ts">
const { height = 29, width = 200 } = defineProps<{
  height?: string | number | undefined;
  width?: string | number | undefined;
}>();
</script>

<template>
  <v-img src="/logo.svg" :width="width" :height="height" :alt="useRuntimeConfig().public.appName" />
</template>
